import { render } from "./FooterUSGS.vue?vue&type=template&id=7ed0e3ad&scoped=true"
import script from "./FooterUSGS.vue?vue&type=script&lang=js"
export * from "./FooterUSGS.vue?vue&type=script&lang=js"

import "./FooterUSGS.vue?vue&type=style&index=0&id=7ed0e3ad&scoped=true&lang=scss"

import exportComponent from "/builds/wma/osd/decap/configuration-depot/configuration-depot-application/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed0e3ad"]])

export default __exports__